import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { Agencies_BranchesProperties } from '../Models/AgencyMasterProperties';
import { BookingListNew, BookingListProperties } from '../Models/BookingListProperties';
import { ImportPnrListProperties } from '../Models/ImportPnrProperties';
import { TicketPnrRights } from '../Models/TicketIssuanceProperties';
import { ImportPnrService } from '../Services/import-pnr.service';

@Component({
  selector: 'app-import-pnr-list',
  templateUrl: './import-pnr-list.component.html',
  styleUrls: ['./import-pnr-list.component.css']
})
/** ImportPnrList component*/
export class ImportPnrListComponent {
  /** ImportPnrList ctor */
  constructor(private importpnrservice: ImportPnrService, private router: Router) {

  }
  importpnrlist: BookingListProperties[] = [];
  userId: number = 0;
  selectedValue: string;
  agencyId: string = "";
  tktPnrRight = new TicketPnrRights();
  bookingNew = new BookingListNew();
  agencyList: Agencies_BranchesProperties[] = [];
  ngOnInit() {
    this.LoadAgencyList();
    this.userId = Number(localStorage.getItem("UserId"));
    this.agencyId = localStorage.getItem("AgencyId");

    this.importpnrservice.CheckTktPnrRightsAgainstAgencyAndUserId(localStorage.getItem("AgencyId"), localStorage.getItem("UserId")).subscribe((data2) => {
      this.tktPnrRight = data2;
    })
    this.bookingNew.userId = Number(localStorage.getItem("UserId"));
    this.bookingNew.agencyId = this.agencyId;

    this.importpnrservice.getBookingList(this.bookingNew).subscribe((data) => {
      this.importpnrlist = data;
      for (let i = 0; i < this.importpnrlist.length; i++) {
        this.importpnrlist[i].bookingDate = this.importpnrlist[i].bookingDate.split('T')[0];
        this.importpnrlist[i].travelDate = this.importpnrlist[i].travelDate.split('T')[0];
        this.importpnrlist[i].bookingDate = this.importpnrlist[i].bookingDate.split('T')[0];
      }
     
    })
  }


  LoadAgencyList() {
    try {
      let loginAgency = "";


      if ((localStorage.getItem("AgencyId") != undefined) && (localStorage.getItem("") != "") && (localStorage.getItem("AgencyId") != null)) {
        loginAgency = localStorage.getItem("AgencyId")
        if ((localStorage.getItem("UserId") != undefined) && (localStorage.getItem("UserId") != "") && (localStorage.getItem("UserId") != null))
          this.userId = Number(localStorage.getItem("UserId"));
        if (this.userId != 0) {
          this.importpnrservice.GetAllAgencies(loginAgency, this.userId).subscribe((data) => {
            this.agencyList = data;
          });
        }
      }

    }
    catch (e) {
    }
  }

  AgencyCodeChange(value: string) {
    try {
      if (value != "" && value != null && value != undefined) {
        
        this.bookingNew.userId = Number(localStorage.getItem("UserId"));
        this.bookingNew.agencyId = value;
        this.importpnrservice.getBookingList(this.bookingNew).subscribe((data) => {
          this.importpnrlist = data;

        });
      }
    }
    catch (e) { }
  }
  Edit_Click(data) {
    localStorage.setItem('importPNRID', data.bookingID.toString());
    localStorage.setItem("fromroutePageNoright", "ImportPNRPage");
    if (data.offlineStatus == "0") {
      localStorage.setItem('isOfflineParked', "False");
    }
    else {
      localStorage.setItem('isOfflineParked', "True");
    }
    this.router.navigateByUrl('/importPNR');

  }

}
